import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { JewelleryTierType } from '../../../models/item-data-models';

@Component({
  selector: 'app-jewellery-tier-icon',
  imports: [],
  templateUrl: './jewellery-tier-icon.component.html',
  styleUrl: './jewellery-tier-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JewelleryTierIconComponent {
  iconMap: Record<JewelleryTierType, string> = {
    Excellent: 'icon-star-4',
    Good: 'icon-star-3',
    Special: 'icon-star-2',
    Other: 'icon-star-1',
  };

  colorClassMap: Record<JewelleryTierType, string> = {
    Excellent: 'tier-master-color',
    Good: 'tier-elite-color',
    Special: 'tier-expert-color',
    Other: 'tier-basic-color',
  };

  tier = input<JewelleryTierType>('Other');

  iconClass = computed(() => this.iconMap[this.tier()] || 'icon-star-1');

  colorClass = computed(() => this.colorClassMap[this.tier()] || 'tier-basic-color');

  spanClass = computed(() => `${this.iconClass()} ${this.colorClass()}`);
}
